// js/sections/collection-list.js
import { timeline as timeline8, inView as inView6 } from 'vendor';
if (!window.customElements.get('collection-list')) {
	var CollectionList = class extends HTMLElement {
		connectedCallback() {
			if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
				inView6(this, this._reveal.bind(this), { margin: '-100px' });
			}
		}
		_reveal() {
			const toReveal = Array.from(this.querySelectorAll('[reveal-js]'));
			timeline8([
				[toReveal, { opacity: 1 }, { duration: 0 }],
				[toReveal.map((item) => item.querySelector('img, svg')), { opacity: [0, 1], transform: ['scale(1.03)', 'auto'] }, { duration: 0.2 }],
				[toReveal.map((item) => item.querySelector('.collection-card__content-wrapper')), { opacity: [0, 1] }, { duration: 0.2 }],
			]);
		}
	};
	window.customElements.define('collection-list', CollectionList);
}
